import { render, staticRenderFns } from "./indextree.vue?vue&type=template&id=2a4be4c3&scoped=true&"
import script from "./indextree.vue?vue&type=script&lang=js&"
export * from "./indextree.vue?vue&type=script&lang=js&"
import style0 from "./indextree.vue?vue&type=style&index=0&id=2a4be4c3&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a4be4c3",
  null
  
)

export default component.exports